import PARENT from '../types';

const SELECTED_SAMPLE_ID = `${PARENT}/SELECTED_SAMPLE_ID`;

export const SET_SELECTED_SAMPLE_ID = `${SELECTED_SAMPLE_ID}/SET`;

export default SELECTED_SAMPLE_ID;
